// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OLIn","label":"styles_label__3645g"};